import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { replaceTo } from 'navigation'
import ChangePasswordPage from '../components/ChangePasswordPage'
import { actions } from '../modules/Password'
import { isBlockConsent } from '../../../../Consent/utils/consentUtils'

export const mapStateToProps = state => {
  const { consent, login, password, strings, user } = state
  const safeLogin = login || {}
  const safeUser = user || {}
  const safeStudy = safeUser.study || {}
  // Temporary-password change must take priority over blocking consent.
  // If we redirect to /consent here, new participants can get stuck and never reach password change.
  const showConsentModal = !safeUser.is_temporary_password && isBlockConsent(user, consent)
  return {
    password,
    strings,
    tempPassword: safeLogin.tempPassword || '',
    isTempPassword: Boolean(safeUser.is_temporary_password),
    needsConsent: Boolean(safeStudy.consent_required && !safeUser.has_consented),
    showConsentModal
  }
}

const mapDispatchToProps = { ...actions }

export function ChangePasswordPageContainerWithConsentGuard(props) {
  const { showConsentModal, ...rest } = props
  useEffect(() => {
    if (showConsentModal) replaceTo('/consent')
  }, [showConsentModal])
  if (showConsentModal) return null
  return <ChangePasswordPage {...rest} />
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordPageContainerWithConsentGuard)
